import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, debounceTime, map, mergeMap } from 'rxjs/operators';
import { FilterSettingsService } from '../services/filter-settings.service';
import {
  filterSettingsActionTypes,
  LoadFilterSettingsAction,
  LoadFilterSettingsFailsAction,
  LoadFilterSettingsSuccessAction, SaveFilterSettingsAction
} from './filter-settings.actions';
import { FilterSettingsRequest } from '../models';
import { distinctUntilChanged } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class FilterSettingsEffects {
  constructor(
    private actions$: Actions,
    private filterSettingsService: FilterSettingsService,
  ) { }

  public loadFilterSettings$ = createEffect(() => this.actions$.pipe(
    ofType<LoadFilterSettingsAction>(filterSettingsActionTypes.LOAD_FilterSettings),
    map(action => action.payload),
    mergeMap((request: FilterSettingsRequest) =>
      this.filterSettingsService.getFilterSettings(request.propertyId, request.reportId)
        .pipe(
          map(response => new LoadFilterSettingsSuccessAction(response)),
          catchError(error => of(new LoadFilterSettingsFailsAction(error)))
        )
    ))
  );

  public saveFilterSettings$ = createEffect(() => this.actions$.pipe(
    ofType<SaveFilterSettingsAction>(filterSettingsActionTypes.SAVE_FilterSettings),
    map(action => action.payload),
    debounceTime(400),
    distinctUntilChanged(),
    mergeMap(request =>
      this.filterSettingsService
        .saveFilterSettings(request)
        .pipe(
          map(response => new LoadFilterSettingsSuccessAction(response)),
          catchError(error => of(new LoadFilterSettingsFailsAction(error)))
        )
    ))
  );
}
